import { render, staticRenderFns } from "./TextEntity.vue?vue&type=template&id=5fe63490&scoped=true&"
import script from "./TextEntity.vue?vue&type=script&lang=js&"
export * from "./TextEntity.vue?vue&type=script&lang=js&"
import style0 from "./TextEntity.vue?vue&type=style&index=0&id=5fe63490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe63490",
  null
  
)

export default component.exports